import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const updateCampaign = (req: any, tokens: any, id: any, isDuplicate: boolean) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: !!id && !isDuplicate? `${APIEndPoints.updateCampaign}` : `${APIEndPoints.createCampaign}`,
    method: 'POST',
    cache: false,
    body: req,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { updateCampaign }
